import React, { useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

const YoEslider = (props) => {
  const [SelectedRange, setSelectedRange] = useState(props.Default);

  const handleRangeChange = (Range) => {
    setSelectedRange(Range);
    props.ChangeEvent();
  };

  return (
    <div className="single-slider-wrapper">
      <Slider
        step={1}
        min={1}
        defaultValue={props.Default}
        max={50}
        onChange={(Range) => handleRangeChange(Range)}
      />
      <div id="yoe-single" className="yoe-range">
        {SelectedRange}
      </div>
    </div>
  );
};

export default YoEslider;
